{
  "en": {
    "navbar": {
      "customer": {
        "after_care": "Aftercare",
        "dashboard": "Dashboard",
        "decisions": "Decisions",
        "documents": "Documents",
        "inspirations": "Inspirations",
        "installments": "Financials",
        "profile": "Your Profile",
        "projectinfo": "Information",
        "question_lists": "FAQ",
        "surveys": "Surveys",
        "ticket": {
          "new": "New Conversation"
        },
        "tickets": "Conversations",
        "units": "As-built"
      },
      "employee": {
        "all_projects": "All Projects",
        "client": "Profile {client}",
        "contacts": "Contacts",
        "customer": "Customer",
        "dashboard": "Dashboard",
        "employee": "Team member",
        "partner": "Partner",
        "profile": "Your Profile",
        "project": {
          "after_care": "Aftercare",
          "decisions": "Decisions",
          "documents": "Documents",
          "email_conversations": "Inbound emails",
          "info": "Information",
          "installments": "Financials",
          "milestones": "Milestones",
          "news": "News Feed",
          "question_lists": "FAQs",
          "sales": "Sales",
          "surveys": "Surveys",
          "todos": "Tasks"
        },
        "projects": "Projects",
        "ticket": {
          "new": "New Conversation"
        },
        "tickets": "Conversations"
      },
      "landmarks": {
        "employee": {
          "client": {
            "primary": "Primary navigation",
            "secondary": "Secondary navigation"
          }
        }
      },
      "partner": {
        "contacts": "Contacts",
        "dashboard": "Dashboard",
        "profile": "Your Profile",
        "project": {
          "after_care": "Aftercare",
          "decisions": "Decisions",
          "documents": "Documents",
          "tickets": "Conversations"
        },
        "projects": "Projects"
      },
      "topnavbar": {
        "company": "Company",
        "helpcenter": "Help center",
        "logout": "Log out",
        "profile": "Profile",
        "searchTeam": "Search company",
        "selectTeam": "Select company",
        "team": "Team"
      }
    }
  }
}